
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"16","height":"1.5","rx":".75"}}),_c('rect',{attrs:{"width":"16","height":"1.5","y":"14.667","rx":".75"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-width":"1.5","d":"M2.222 11.858l11.673-4.876M2.222 8.658l11.673-4.876M2.222 5.458l3.9-1.53m3.756 7.854l4.017-1.6"}})])])
          )
        }
      }
    